import { getConfig } from '@superbet-group/web.lib.config';
import { Sponsorship } from '@src/federations/shared/cms/sponsorships/Sponsorship';

export async function getSponsorships(target: string): Promise<Sponsorship[]> {
    const sponsorships = await fetch(`${getConfig().cms?.baseUrl}/cached-superbet/sponsorships/${target}`);
    return await sponsorships.json();
}
